<template>
  <div class="basePresentacion p-0 p-lg-0 pb-5">

      <div class="presentacion col-12 col-lg-6 offset-0 offset-lg-5 my-5"  data-aos="fade" data-aos-delay="250" data-aos-easing="linear" data-aos-duration="1000">

          <div class="row g-0">
              <div class="col-12 col-lg-10 m-auto p-3 p-xl-3 text-start">
                  <h3 class="h3Presentacio mt-5 mb-4 text-dark text-dark-mobil"><strong>{{ $t('presentacion.presentacion') }}</strong></h3>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p1')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p2')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p3')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p4')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p5')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p6')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p7')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p8')"></p>
                  <p class="py-2 ps-1 ps-lg-0" v-html="$t('presentacion.presentacion-p9')"></p>
                  <p>&nbsp;</p>
                  <p class="py-0 py-lg-3 ps-1 ps-lg-0"><strong>SANTIAGO DE GOMAR ROCA</strong><br>{{ $t('presentacion.presidente') }}</p>
                  <p class="d-none d-lg-block"><img :src="`${publicPath}img/RG_firma.png`"></p>
                  <p class="d-block d-lg-none"><img :src="`${publicPath}img/RG_firmaMobile.png`"></p>
              </div>
          </div>
      </div>
  </div>

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{$t('site.home')}}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/roca-group-2022/2022-en-resumen" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{$t('nav.resumen')}}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->
</template>

<script>
  export default {
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
  };
</script>
